import { NgModule } from '@angular/core';
import { FNDateRangePickerComponent } from './fn-date-range-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	NgbDatepickerConfig,
	NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, CommonModule } from '@angular/common';
import { FnDatepRangeConfig } from './fn-date-range-config';
import { FoundationModule } from '../../foundation.module';

export * from './fn-date-range-picker.component';
export * from './fn-date-range-config';

/**
 * Provide FnDatepRangeConfig to globally configuration DateRangePicker.
 * And Exports the required FNDateRangePickerComponent to create DateRangePicker Element.
 * making them available for import by NgModules that import this module.
 */
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbDatepickerModule,
		FoundationModule,
	],
	exports: [FNDateRangePickerComponent],
	declarations: [FNDateRangePickerComponent],
	providers: [
		DatePipe,
		{
			provide: NgbDatepickerConfig,
			useClass: FnDatepRangeConfig,
		},
	],
})
export class FnDateRangePickerModule {}
